/**
 * Übersicht aller Rezepte.
 */
import { RecipeBrowser } from '../components/RecipeBrowser.tsx';
import { texts } from '../texts/de.ts';

/** Startseite mit allen Rezepten. */
export function RecipeListPage() {
  return <RecipeBrowser mode="list" title={texts.recipes.title} subtitle={texts.app.tagline} />;
}
